import WarningIcon from "assets/warning.svg";

const Modal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-10 bg-black bg-opacity-60 font-sans">
      <div className="bg-white rounded-lg p-6 shadow-xl max-w-sm w-full transform transition-all duration-300 ease-out scale-100 opacity-100">
        <div className="flex flex-col items-center mb-4">
          <div className="text-red-500 mb-3 flex items-center gap-2">
            <img className="w-8 h-8" src={WarningIcon} alt="warning" />
            <h2 className="font-semibold text-gray-800">{title}</h2>
          </div>
          <p className="text-xs text-gray-500 text-center">{message}</p>
        </div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={onClose}
            className="w-full px-6 py-1 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 transition duration-150 ease-in-out"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className="w-full px-6 py-1 rounded-lg bg-red-500 text-white hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 transition duration-150 ease-in-out shadow-md"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
